import { execOnLoad } from '@general/helpers';
import './not-found-page.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initNotFoundPage = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const container = sectionContainer.querySelector('.not-found-page__container');
  if (!container) return;

  const query = window.location.pathname.replace(window.Shopify.routes.root, '').split('/').pop();
  fetch(
    `${window.Shopify.routes.root}search/suggest?q=${query}&resources[type]=product,collection&section_id=not-found-page`,
  )
    .then((res) => res.text())
    .then((data) => {
      const sectionDom = new DOMParser().parseFromString(data, 'text/html');
      const carousel = sectionDom.querySelector('.carousel__container');
      if (!carousel) return;
      container.appendChild(carousel);
      if (typeof window?.dAgency?.initCarousel == 'function') window.dAgency.initCarousel(carousel);

      if (typeof window?.dAgency?.initProductTile == 'function')
        carousel.querySelectorAll('.product-tile__container').forEach((tile) => window.dAgency.initProductTile(tile));
    });
};

execOnLoad(window.dAgency.initNotFoundPage, '.not-found-page__section');
